import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../../assets/images/logo.png'
import googleicon from '../../assets/images/google-icon.png'
import facebookicon from '../../assets/images/facebook-icon.png'
import Login from './Authentication/Login'
import FirstTimeProfileModal from './Authentication/FirstTimeProfileModal'
import LoginOtp from './Authentication//LoginOtp'
import SignUp from './Authentication/SignUp'
import { useSelector } from 'react-redux'
import appstore from '../../assets/images/appstore2.png'
import playstore from '../../assets/images/playstore-02.png'

function Footer() {
    const [propMobile, setPropMobile] = useState();
    const { commonwebData } = useSelector(state => state.auth);
    const navigate = useNavigate();

    // Function to handle footer link clicks and scroll to top
    const handleFooterLinkClick = (e, path) => {
        e.preventDefault();
        // Scroll to top of the page
        window.scrollTo(0, 0);
        // Navigate to the specified path
        navigate(path);
    };

    return (
        <>
            <footer className="modern-footer">
                <div className="container">
                    <div className="modern-footer-content">
                        <div className="row">
                            {/* Company Info & Social Media */}
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="modern-footer-logo">
                                    <Link to="/" onClick={(e) => handleFooterLinkClick(e, '/')}>
                                        <img src={logo} alt="Fynito Logo" />
                                    </Link>
                                </div>
                                <p className="modern-footer-description">
                                    Welcome to Fynito, your one-stop solution for effortless food
                                    delivery. We bring delicious meals right to your doorstep with speed and care.
                                </p>
                                <div className="modern-social-media">
                                    <Link to="https://www.facebook.com/fynitoapp" target='blank' className="modern-social-link">
                                        <i className="fab fa-facebook-f" />
                                    </Link>
                                    <Link to="https://www.instagram.com/fynitoapp" target='blank' className="modern-social-link">
                                        <i className="fab fa-instagram" />
                                    </Link>
                                    <Link to="https://www.youtube.com/@fynitoapp" target='blank' className="modern-social-link">
                                        <i className="fab fa-youtube" />
                                    </Link>
                                    <Link to="https://x.com/fynitoapp" target='blank' className="modern-social-link">
                                        <i className="fa-brands fa-x-twitter" />
                                    </Link>
                                    <Link to={`${commonwebData?.whatsapp_link}`} target='blank' className="modern-social-link">
                                        <i className="fa-brands fa-whatsapp" />
                                    </Link>
                                </div>
                            </div>

                            {/* Company Links */}
                            <div className="col-lg-2 col-md-6 col-sm-6">
                                <div className="modern-footer-section">
                                    <h4>Company</h4>
                                    <ul className="modern-footer-links">
                                        <li>
                                            <Link to="/about-us" onClick={(e) => handleFooterLinkClick(e, '/about-us')}>
                                                About Us
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/contact-us" onClick={(e) => handleFooterLinkClick(e, '/contact-us')}>
                                                Contact Us
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {/* Legal Links */}
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="modern-footer-section">
                                    <h4>Legal</h4>
                                    <ul className="modern-footer-links">
                                        <li>
                                            <Link to="/term-condition" onClick={(e) => handleFooterLinkClick(e, '/term-condition')}>
                                                Terms & Conditions
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/refund-policy" onClick={(e) => handleFooterLinkClick(e, '/refund-policy')}>
                                                Refund Policy
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/privacy-policy" onClick={(e) => handleFooterLinkClick(e, '/privacy-policy')}>
                                                Privacy Policy
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/shipping-policy" onClick={(e) => handleFooterLinkClick(e, '/shipping-policy')}>
                                                Shipping Policy
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {/* Download Apps */}
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="modern-footer-section">
                                    <h4>Download App</h4>
                                    <div className="modern-download-section">
                                        <h5>Get the Fynito app</h5>
                                        <div className="modern-download-buttons">
                                            <a href="https://apps.apple.com/in/app/fynito/id6739328008" target="_blank" rel="noopener noreferrer" className="modern-download-btn">
                                                <img src={appstore} alt='App Store' />
                                            </a>
                                            <a href="https://play.google.com/store/apps/details?id=com.fynito.user&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="modern-download-btn">
                                                <img src={playstore} alt='Play Store' />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer Bottom */}
                        <div className="modern-footer-bottom">
                            <p>&copy; 2024 Fynito. All rights reserved. | Delivering happiness, one meal at a time.</p>
                        </div>
                    </div>
                </div>
            </footer>

            {/* login-modal-start */}
            <Login />
            {/* login-modal-end */}
            {/* firsttime-profile-modal-start */}
            <FirstTimeProfileModal />
            {/* firsttime-profile-modal-end */}
            {/* otp-modal-start */}
            {/* <LoginOtp propMobile={propMobile} /> */}
            {/* otp-modal-end */}
            {/* signup-modal-start */}
            <SignUp />
            {/* signup-modal-end */}
        </>
    )
}

export default Footer